import PopupBuilder from '@services/payment/PopupBuilder';
import type {PaySelectionConstructor, PaySelectionPopupParams} from '@interfaces/PaySelection';
import type ValueList from '@interfaces/ValueList';
import type {RecurrentParams} from '@interfaces/PaymentPopup';
import Analytics from '@services/analytics/Analytics';
import {generateRandomString} from '@utils/stringUtils';

declare global {
    interface Window {
        pw: {
            PayWidget: PaySelectionConstructor;
        };
    }
}

const orderIdLength = 16;

export default class PaySelectionPopup extends PopupBuilder {
    private readonly params: PaySelectionPopupParams;
    private extraData: ValueList = {};
    private recurrentData: RecurrentParams;

    public constructor(email: string, description: string) {
        super();
        this.params = {
            MetaData: {
                PaymentType: 'Pay',
            },
            PaymentRequest: {
                OrderId: generateRandomString(orderIdLength),
                Amount: '0',
                Currency: 'RUB',
                Description: description,
                RebillFlag: true,
                ExtraData: {},
            },
            CustomerInfo: {
                Email: email,
                ReceiptEmail: email,
            },
        };
    }

    public setCustomData(params: ValueList): this {
        this.extraData = params;
        return this;
    }

    public setRecurrentData(params: RecurrentParams): this {
        this.recurrentData = params;
        return this;
    }

    public setItem(_description: string, price: number): this {
        this.params.PaymentRequest.Amount = String(
            Number(this.params.PaymentRequest.Amount) + price,
        );
        return this;
    }

    public setCompleteHandler(): this {
        return this;
    }

    public async buildCharge(): Promise<unknown> {
        this.params.MetaData.PaymentType = 'Pay';
        return this.build();
    }

    public async buildAuth(): Promise<unknown> {
        this.params.MetaData.PaymentType = 'Block';
        return this.build();
    }

    public async build() {
        const widget = new window.pw.PayWidget();
        return new Promise((resolve, reject) => {
            widget.pay(
                {
                    serviceId: window.bootstrapParams.paySelectionSiteId,
                    key: window.bootstrapParams.paySelectionPublicKey,
                    logger: false,
                },
                this.getPopupParams(),
                {
                    onSuccess(result) {
                        resolve(result);
                    },
                    onError(result) {
                        reject(Error(result.code));
                    },
                    onClose: result => {
                        Analytics.triggerEvent(
                            `Закрытие виджета оплаты без покупки${
                                this.params.MetaData.PaymentType === 'Block'
                                    ? ' (двухфакторный)'
                                    : ''
                            }`,
                            'widgetReject',
                            [result.code],
                        );
                        reject(Error(result.code));
                    },
                },
            );
        });
    }

    private getPopupParams(): PaySelectionPopupParams {
        const extraData = {
            ...this.extraData,
            ...this.recurrentData,
        };

        this.params.PaymentRequest.ExtraData.paperData = JSON.stringify(extraData);
        return this.params;
    }
}
